<div class="am-flex-center fixed-full entries-pills-popup-wrapper">
  <div class="absolute-full popup-overflow" (click)="closePopup()"></div>
  <div class="entries-pills-popup m-l m-0-mobile bg-white b-grey am-flex-column height-full width-full b-radius-wide-i z-1 absolute-mobile absolute-mobile-full">
    <div class="am-flex-justify gap-s p-m bb-grey">
      <div class="am-flex-align gap-xs">
        <span class="font-icon am-flex-center icon-pin color-blue"></span>
        <span class="font-500">{{ title }} wählen</span>
      </div>
      <span class="font-icon-small am-flex-center icon-cross hover-active" (click)="closePopup()"></span>
    </div>

    <div class="am-flex-column p-m gap-s bb-grey">
      <div class="relative width-full">
        <input #pillsSearch id="search-entry" class="width-full" [(ngModel)]="search" type="text">
       @if ( search) { <span class="am-flex-center pl-xs pr-xs pt-s pb-s absolute-right-center font-s pointer icon-cross" (click)="search = null"></span> }
        @if (!search && pillsSearch !== document?.activeElement) {
          <span class="absolute-left-center ml-xs am-flex-align gap-xxs color-disabled" (click)="pillsSearch?.focus()">
            <span class="am-flex-center font-icon icon-search"></span>
            <span class="font-s">Stadt oder {{ title }} suchen…</span>
          </span>
        }
      </div>

      @if (isInternal) {
        <div class="am-flex-justify gap-m font-s">
          <span class="am-flex-align am-flex-mobile-column am-flex-mobile-align-start gap-xxs" [ngClass]="nonePillsSecected ? 'bg-light-blue pt-xxs pb-xxs pl-xs pr-xs b-radius-wide' : ''">
            @if        (nonePillsSecected) {
              <span class="font-500">Keine Auswahl</span>
              <span class="color-blue xs-hide">- alle {{ filterEntriesBySearch(popupPills).length }} Niederlassungen werden angezeigt</span>
              <span class="color-blue xs-show">Alle werden angezeigt</span>
            } @else if (allPillsSecected)  {
              <span class="font-500">Alle {{ filterEntriesBySearch(popupPills).length }}</span>
              <span>Niederlassungen ausgewählt</span>
            } @else {
              <span class="font-500">{{ filterEntriesBySearch(activePills).length }} von {{ filterEntriesBySearch(popupPills).length }}</span>
              <span>ausgewählt</span>
            }
          </span>

          <div class="am-flex-align gap-xs">
            <button class="custom width-90 pt-xxs pb-xxs pl-xs pr-xs b-grey color-secondary-grey hover-active-blue" [disabled]="allPillsSecected"  (click)="selectAll(filterEntriesBySearch(popupPills))"  >Alle wählen</button>
            <button class="custom width-90 pt-xxs pb-xxs pl-xs pr-xs b-grey color-secondary-grey hover-active-blue" [disabled]="nonePillsSecected" (click)="deselectAll(filterEntriesBySearch(popupPills))">Keine</button>
          </div>
        </div>
      }
    </div>

    <div class="am-flex-column am-flex-1 overflow-auto">
      @if (isInternal) {
      <ng-container *ngTemplateOutlet="list; context: { label: 'Favoriten',     list: filterEntriesBySearch(favouritePills), selected: filterEntriesBySearch(activeFavouritePills), openValue: favouriteOpen, onOpen: this.toggleList.bind(this, 'favouriteOpen'), star: true }"></ng-container> }
      <ng-container *ngTemplateOutlet="list; context: { label: `Alle ${title}`, list: filterEntriesBySearch(popupPills),     selected: filterEntriesBySearch(activePills),          openValue: allOpen,       onOpen: this.toggleList.bind(this, 'allOpen')                   }"></ng-container> 
    </div>

    <div class="am-flex-align gap-s bt-grey pt-s pb-s pl-m pr-m mta">
      <button class="mla white" (click)="closePopup()">Abbrechen</button>
      <button class="blue"      (click)="savePills()">Übernehmen {{ isInternal && activePills.length && activePills.length !== popupPills.length ? `(${activePills.length})` : '' }}</button>
    </div>
  </div>
</div>

<ng-template #list let-label="label" let-list="list" let-selected="selected" let-openValue="openValue"let-star="star" let-onOpen="onOpen">
  <div class="am-flex-column">
    <div class="am-flex-align am-flex-justify pl-m pr-m pb-s pt-s gap-m hover-active" (click)="onOpen()">
      <div class="am-flex-align gap-xs">
        <span class="font-l am-flex-center" [ngClass]="openValue ? 'icon-arrow-down' : 'icon-arrow-right'"></span>
        <div class="am-flex-align gap-xxs font-s">
          @if (star) { <span class="font-l am-flex-center icon-star color-yellow"></span> }
          <span class="color-blue font-500 uppercase">{{ label }}</span>
        </div>
      </div>
      @if (isInternal) {
        <div class="am-flex-align gap-s">
          <span class="b-radius-wide pt-xxs pb-xxs pl-xs pr-xs font-s" [ngClass]="selected.length === list.length ? 'b-blue bg-light-blue color-blue' : 'b-grey'">{{ selected.length }} / {{ list.length }}</span>
          @if (selected.length === list.length) { <span class="width-35 text-right hover-active font-s color-blue" (click)="$event.stopPropagation(); deselectAll(list)">Keine</span> }
          @else                                 { <span class="width-35 text-right hover-active font-s color-blue" (click)="$event.stopPropagation(); selectAll(list)"  >Alle</span>  }
        </div>
      }
    </div>
    @if (openValue) { @for (entry of list | sortBy: ['name'] : false; track entry.id;   let i = $index) { <ng-container *ngTemplateOutlet="pill; context: { entry }"></ng-container> } }
  </div>
</ng-template>

<ng-template #pill let-entry="entry">
  <li class="am-flex-justify gap-m pl-l pr-l pb-xs pt-xs pl-s-mobile pr-s-mobile b-width-2"
      [class.font-500]="     entry.active"
      [class.bl-blue]="      entry.active"
      [class.bg-light-blue]="entry.active"
      [class.bl-white]="    !entry.active"
      [class.disabled]="     entry.disabled"
      (click)="togglePopupEntry($event, entry)">
    <div class="am-flex-align gap-s">
      @if (singleSelect) { <input class="custom-checkbox blue big radio" [id]="'pill_' + i" type="radio"    [(ngModel)]="activeCompany.company_number" [value]="entry.company_number"> }
      @else              { <input class="custom-checkbox blue big"       [id]="'pill_' + i" type="checkbox" [(ngModel)]="entry.active">                                                }
      <label class="am-flex-align entry-select font-s" [for]="'pill_' + i">{{ entry.name }}</label>
    </div>
    <div class="am-flex-align gap-s">
      <span class="font-s">{{ entry.company_number || entry.location }}</span>
      @if (isInternal) { <span class="am-flex-center hover-active p-xxs font-icon" [ngClass]="entry.favourite ? 'icon-star-filled color-yellow' : 'icon-star'" (click)="toggleShowEntry($event, entry)" [class.disabled]="!entry.favourite"></span> }
    </div>
  </li>
</ng-template>
